module.exports = __webpack_public_path__ + "static/img/hdw8.c6058743.png";